/**
* This file is loaded asyncronously in the footer.
* All custom global scripts should be included here.
*/

	/*
	A little info for this js file:

	As much as possible, this file should be kept organized. Currently, two major divisions are seen below, delinitated by their respective functions of "on load" and "ready".
		As mentioned below, most code added to this file should be included within the "on load" function.

	For ease of future use, include any new code at the bottom of the relevant section of the page, adding clear comments to explain the purpose of the code being written,
		including any relavant details regarding what the code overrides, etc.
	*/


(function(){
	'use strict';

	// rerun lazyload on screen size updates
	window.addEventListener( 'resize', function() {
		dbs.lazyload();
	});

	// Load event function ... most custom stuff goes here. Safer for async.
	window.addEventListener( 'load', function() {
		/* Search Form functionality
		 * The click functionality involves three different actions,
		 * depending on conditions the various clicks provide.
		 */
		var searchOpen = document.querySelectorAll( '.search-form__button--open' );
		var searchClose = document.querySelectorAll( '.search-form__button--close' );

		if ( searchOpen ) {
			for (var i=0; searchOpen.length > i; i++) {
				searchOpen[i].addEventListener( 'click', function() {
					this.parentElement.classList.add( 'search-form--active' );
					this.parentElement.querySelector('.site_search__field').focus();
		
					// Hide the search bar after click out of it
					document.getElementById( 'content' ).addEventListener( 'click', function() {
						if ( this.parentElement.classList.contains( 'search-form--active' ) ) {
							this.parentElement.classList.remove( 'search-form--active' );
						}
					});
				});
			}
			
			for (var i=0; searchClose.length > i; i++) {
				searchClose[i].addEventListener( 'click', function() {
					this.parentElement.classList.remove( 'search-form--active' );
				});
			}
		}


		/**
		 * Linkclicker
		 * 
		 * A class placed on a wrapping element with a link inside to make the wrapper clickable.
		 * Note: the container should have only one link.
		 */
		var linkclickers = document.querySelectorAll('.linkclicker');

		for ( var i = 0; linkclickers.length > i; i++ ) {
			var linkclicker = linkclickers[i];

			linkclicker.addEventListener('click', function(e) {
				e.preventDefault();
				var link = this.querySelector('a');
				var linkPath = link.getAttribute('href');
				
				if ( link.getAttribute('target', "_blank") ) {
					window.open(linkPath);
				} else {
					window.location.href = linkPath;
				}
			});
		}


		/**
		 * Force external links/PDFs to open in a new tab.
		 * From https://stackoverflow.com/questions/2910946/test-if-links-are-external-with-jquery-javascript
		 * 2019-07-11 - TA
		 */
		function link_is_external(link_element) {
			return ( link_element.host !== window.location.host || link_element.href.indexOf("pdf") > -1 );
		}

		var anchorElements = document.getElementsByTagName('a');
		for ( let anchorElement of anchorElements ) {

			if ( link_is_external( anchorElement ) ) {
				anchorElement.setAttribute( 'target','_blank' );
				anchorElement.setAttribute( 'rel','noopener' );

				// Add assistive text to alert of external links
				var assistiveText = '<span class="assistive">. External Link. Opens in new window.</span>';
				var assistiveTextContainer = document.createElement( 'span' );
				assistiveTextContainer.innerHTML = assistiveText;
				anchorElement.appendChild( assistiveTextContainer.firstChild );
			}
		}

		/**
		 * Detects if element is in viewport and add class
		 */
		function observeElements(elements, className, options = {}) {
			// Create an Intersection Observer
			const observer = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						entry.target.classList.add(className); // Add class when in view
					}
				});
			}, options);
			
			// Observe each element in the NodeList
			elements.forEach((element) => observer.observe(element));
		}

		const elements = document.querySelectorAll('.animated'); // Elements to observe
		const options = {
			root: null, // Default: viewport
			rootMargin: '0px 0px 0px 0px', // Adjust based on layout
			threshold: 0.3, // Trigger when 10% of the element is visible
		};
		observeElements(elements, 'in-view', options); // Start observing

		/**
		 * Captures Google Analytics Client ID and inputs into hidden form field
		 */
		var g_id = document.querySelector('#contact_form-form-client_id-field' );

		function fillClientId() {
			// Capture Client ID
			var clientId = document.cookie.match(/_ga=(.+?);/)[1].split('.').slice(-2).join(".");
			// Populate hidden form field with Client ID
			g_id.value = clientId;
		}

		// On pages with client ID form field and analytics is loaded, populate
		if ( g_id && Object.keys( window.google_tag_manager || [] ).filter( e => { return e.substring(0,2) == 'G-' } ).length > 0 ) {
			// Give GTM time to load
			setTimeout(function() {
				fillClientId();
			}, 5000);
		}

		// Prevent double-initialisation if this file somehow gets included twice
		if (window.__collapsibleInit) return;
		window.__collapsibleInit = true;

		// Add "loaded" class so CSS can hide/show only when JS is active
		function initCollapsibleContent() {
			var contents = document.querySelectorAll('.collapsible-row__content--wrapper');
			contents.forEach(function (content) {
				content.classList.add('loaded');
			});
		}

		// Event delegation: one global click listener for all current & future collapsibles
		function handleCollapsibleClick(event) {
			var header = event.target.closest('.collapsible-row__header');
			if (!header) return; // clicked something else

			var row = header.closest('.collapsible-row');
			if (!row) return;

			row.classList.toggle('expanded');
		}

		// Run when DOM is ready
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', initCollapsibleContent);
		} else {
			initCollapsibleContent();
		}

		// Single click listener on the document
		document.addEventListener('click', handleCollapsibleClick);
	}); // End of load function


	/**
	 * Cookie Popup scripts
	 */
	var popUp		= document.getElementById('cookie-popup');
	var popUpMain	= document.getElementById('popup-main');

	// Hide popup and background filter and set cookie
	function accept() {
		popUp.style.display = "none";
		document.body.classList.add('cookies');
		setCookie( "accepts-cookie", "accepts-cookie-set", 365 );
	}

	document.getElementById('accept-button').addEventListener( 'click', function() {
		accept();
	});

	var cookie = readCookie( 'accepts-cookie' );
	// If user already has accepted cookies, don't show popup
	if ( cookie == 'accepts-cookie-set' ) {
		popUp.style.display = "none";
	} else {
		// Force screen reader to read popup
		popUpMain.setAttribute("aria-live", "assertive");
	}
})();
